import '../../vendor/flickity.pkgd.min.js';

/**
 * Initialize Flickity Slider for Slider-articles
 *
 * @param {}
 * @return {void}
 */

export const initializeSliderArticles = (slider = '.js-slider-articles') => {
  let group = 1;
  let lazyLoad = true;

  if ($(window).outerWidth() > 1024) {
    group = 3;
  }

  const config = {
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    prevNextButtons: true,
    groupCells: true,
    freeScroll: true,
    wrapAround: false,
    lazyLoad: false,
    groupCells: group,
    cellSelector: '.slider__slide'
  };

  $(slider)
    .not('.flickity-enabled')
    .flickity(config);

  $('.js-slider-articles .js-responsive-background-image').each(function() {
    $(this).addClass('lazyloaded');
  });
};

$(window).on('load', function(event) {
  initializeSliderArticles();
});
